import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useCallback } from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { showModal } from '../../redux/actions/activeModal.actions';
import { ModalName } from '../../types/ModalNames';
import ChevronLeft from 'wix-ui-icons-common/ChevronLeft';

import { Box, Button } from 'wix-style-react';

interface IPageActionBarProps extends InjectedTranslateProps {
    onCancel?: Function;
    onOk?: Function;
    onCancelTextKey?: string;
    onOkTextKey?: string;
    isPageDirty?: boolean;
    isEditable?: boolean;
    modalOnSave?: string;
    modalOnSaveParams?: {[key: string]: any};
    origin: string;
}

const PageActionBar: React.FC<IPageActionBarProps> = ({ t, onCancel, onOk, isPageDirty, isEditable, modalOnSave, modalOnSaveParams, onCancelTextKey, onOkTextKey, origin }) => {
    const dispatch = useDispatch();

    const history = useHistory();

    const onSaveAction = useCallback(() => {
        if (modalOnSave) {
            dispatch(showModal(ModalName[modalOnSave], modalOnSaveParams));
        } else {
            onOk();
        }
    }, [modalOnSave, modalOnSaveParams, onOk, dispatch]);

    const onBackOrCancelAction = useCallback(() => {
        if (isPageDirty) {
            dispatch(showModal(ModalName.DiscardChanges, { onOk: onDiscardChanges }));
        } else {
            goBack();
        }
    }, [dispatch, isPageDirty]);

    const goBack = useCallback(() => {
        return history.push('/', { origin });
    }, [history, origin]);

    const onDiscardChanges = useCallback(() => {
        if (onCancel) {
            onCancel();
        }
        goBack();
    }, [onCancel]);

    return (
        <Box>
            <Box minWidth="110px" paddingRight="small">
                <Button
                    fullWidth
                    dataHook={'page-back-button'}
                    priority={'secondary'}
                    onClick={onBackOrCancelAction}
                    prefixIcon={isEditable ? undefined : <ChevronLeft/>}
                >
                    {t(onCancelTextKey ? onCancelTextKey : isEditable ? 'page.actionBar.cancel' : 'page.actionBar.back')}
                </Button>
            </Box>
            {isEditable &&
                <Box minWidth={ onOkTextKey ? '134px' : '110px' }>
                    <Button fullWidth
                            dataHook={'page-action-button'}
                            onClick={onSaveAction}>
                        {t(onOkTextKey ? onOkTextKey : 'page.actionBar.save')}
                    </Button>
                </Box>
            }
        </Box>
    );
};

export default React.memo(translate()(PageActionBar));
